import { takeLeading, put, all, call, select } from 'redux-saga/effects';

import axios from 'axios';

import {
  fetchStationChecklistSuccess,
  fetchStationChecklistFailure,
} from './station-checklist.actions';

import { selectCurrentUser } from '../user/user.selector';

import StationChecklistActionTypes from './station-checklist.types';

export function* getStationChecklistData() {
  let user = yield select(selectCurrentUser);
  try {
    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/stationChecklist/current',
      method: 'post',
      data: {
        userAuth: user,
      },
    });

    let checklist = {};

    if (response.data) {
      for (let station of response.data) {
        let tempSpot = {
          id: '',
          FUELED: '',
          'Fuel Amount': 0,
          'Potable Water': '',
          'LAV completed': '',
          Spot: '',
        };
        let spots = [];

        for (let key of Object.keys(station)) {
          if (!station[key]) continue;
          try {
            let t = {};
            t[key] = station[key];
            let spot = isSpot(t);

            if (spot) {
              console.log(spot);
              let spotExists = spots.find((s) => s.id === spot.id);
              if (spotExists) {
                //spot exists
                spotExists = { ...spotExists, ...spot };
                spots[spots.findIndex((s) => s.id === spot.id)] = spotExists;
                console.log(spotExists);
              } else {
                //spot does not exist
                spots.push({ ...tempSpot, ...spot });
              }
            }
          } catch (error) {
            console.log(error);
          }
        }

        checklist[station.FBO] = {
          station: station.FBO,
          spots,
          hangar: station.Hangar,
          notes: station.Notes,
          updateTime: station['Update Time'],
          date: station['Schedule Date'],
          dutyManager: station['Duty Manager'],
          ascAM: station['ASC AM'],
          ascPM: station['ASC PM'],
          valetAM: station['Valet AM'],
          valetPM: station['Valet PM'],

          ascSupAM: station['ASC Supervisor AM'],
          ascSupMid: station['ASC Mid Shift Sup'],
          ascSupPM: station['ASC Supervisor PM'],
          oscAM: station['OSC AM'],
          oscPM: station['OSC PM'],
          oscSupAM: station['OSC Supervisor AM'],
          oscSupMid: station['OSC Mid Shift Sup'],
          oscSupPM: station['OSC Supervisor PM'],
          PTO: station['Crewmembers on PTO'],
          sick: station['Crewmember Sickcall'],
          WX: station['WX'],
          opsStats: {
            opsIssues: station['OPS ISSUES'],
            totalInbound: station['TOTAL INBOUNDS'],
            totalOutbound: station['TOTAL OUTBOUNDS'],
            totalDelay: station['TOTAL DELAYS'],
            charter: station['CHARTERS'],
            cancellations: station['CANCELLATIONS'],
            fleetLaunch: station['FLEET LAUNCH'],
            RON: station["RON's"],
          },
        };
      }
    }

    //   yield put(getLastRunSuccess(response.data.lastrun));
    // yield console.log(checklist);
    yield put(fetchStationChecklistSuccess(checklist));
  } catch (error) {
    alert('Error on server while getting checklist data');
    yield put(fetchStationChecklistFailure(error));
  }
}

export function* onFetchStationChecklistStart() {
  yield takeLeading(
    StationChecklistActionTypes.FETCH_STATION_CHECKLIST_START,
    getStationChecklistData
  );
}

export function* stationChecklistSagas() {
  yield all([call(onFetchStationChecklistStart)]);
}

function isSpot(obj) {
  let key = Object.keys(obj)[0];
  let value = obj[key];
  //   console.log(obj);
  if (
    key.includes('FUELED') ||
    key.includes('Fuel Amount') ||
    key.includes('Potable Water') ||
    key.includes('LAV completed') ||
    key.includes('Spot')
  ) {
    let t = {};
    t[key.split('-')[0].trim()] = value;
    return {
      id: key.split('-')[1].trim(),

      ...t,
    };
  }
  return false;
}
